import { Link } from "react-router-dom";
import type { ArtistRef } from "../types";

/** "Kygo, Dido feat. Conrad Sewell" with every name linking to the artist page. */
export function ArtistLinks({ artists, fallback }: { artists: ArtistRef[]; fallback: string }) {
  if (!artists.length) return <>{fallback}</>;
  const main = artists.filter((a) => a.role === "main");
  const featured = artists.filter((a) => a.role === "featured");
  const list = (xs: ArtistRef[]) =>
    xs.map((a, i) => (
      <span key={a.id}>
        {i > 0 && ", "}
        <Link to={`/wykonawca/${a.id}`}>{a.name}</Link>
      </span>
    ));
  return (
    <>
      {list(main.length ? main : artists)}
      {main.length > 0 && featured.length > 0 && <span className="feat"> feat. </span>}
      {main.length > 0 && list(featured)}
    </>
  );
}
